export default __webpack_public_path__ + "92119f36b1802836a41c088cf49242d7.png";